import { NullMessage } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form-mui';
import { FormattedMessage } from 'react-intl';
import { VariantSelector } from '../../../../../../fragments/screens/view/components/audiogram/preview/VariantSelector';
import { AudiogramPlayer } from '../../../../../../fragments/screens/view/components/audiogram/social-export/AudiogramPlayer';
import { FormValues } from '../types';

interface TemplatePreviewProps {
  index: number;
}

export function TemplatePreview({ index }: TemplatePreviewProps) {
  const { watch } = useFormContext<FormValues>();
  const station = watch('station');
  const template = watch(`templates.${index}`);
  const [variant, setVariant] = useState(template.data.variants[0]);

  useEffect(() => {
    if (!template.data.variants.includes(variant)) {
      setVariant(template.data.variants[0]);
    }
  }, [template.data.variants]);

  if (template.data.variants.length === 0) {
    return (
      <NullMessage>
        <FormattedMessage
          id="audiogram.selectAtLeastOneVariant"
          defaultMessage="Debe seleccionar al menos una variante"
        />
      </NullMessage>
    );
  }

  return (
    <Box>
      <VariantSelector variants={template.data.variants} value={variant} onChange={setVariant} />
      <AudiogramPlayer
        audiogramProps={{
          variant: variant as any,
          ...template.data,
          titleText: 'Este es el título del audiogram de prueba de MediaInbox',
          audioFileUrl: 'https://static-app.mediainbox.io/sample-audiogram.mp3', // This should be replaced with actual audio URL
          coverImageUrl: station.logoUrl, // This should be replaced with actual cover URL
          captionsType: 'static',
          captions: [
            {
              text: 'Lorem ipsum dolor sit amet elit',
              startMs: 0,
              endMs: 100,
              timestampMs: 0,
              confidence: 1,
            },
            {
              text: 'consectetur adipiscing sit',
              startMs: 0,
              endMs: 100,
              timestampMs: 0,
              confidence: 1,
            },
            {
              text: 'Excepteur sint occaecat cupidatat',
              startMs: 0,
              endMs: 100,
              timestampMs: 0,
              confidence: 1,
            },
            {
              text: 'enim ad minima veniam, quis',
              startMs: 0,
              endMs: 100,
              timestampMs: 0,
              confidence: 1,
            },
          ],
        }}
        playerProps={{
          renderMuteButton: () => null,
          renderVolumeSlider: () => null,
          initiallyMuted: true,
          loop: true,
        }}
      />
    </Box>
  );
}
